import { useContext } from 'react';

import { EditorContextPanelContext } from '@confluence/editor-context-panel/entry-points/EditorContextPanelContext.ts';
import { useDialogs } from '@confluence/dialogs/entry-points/useDialogs.ts';

import { SnippetEditorModal } from '../modals/SnippetEditorModal.tsx';
import { DeleteSnippetModal } from '../modals/DeleteSnippetModal.tsx';
import { SnippetEditorModalMode, type Snippet } from '../snippetTypes.ts';

export type SnippetActionHandlersOptions = {
	onDuplicate?: (snippet: Snippet) => void;
};

export const useSnippetActionHandlers = (options: SnippetActionHandlersOptions = {}) => {
	const { onDuplicate } = options;
	const { showModal } = useDialogs();
	const { editorAPI } = useContext(EditorContextPanelContext);

	const handleEdit = (snippet: Snippet) => {
		showModal(SnippetEditorModal, {
			mode: SnippetEditorModalMode.EDIT,
			snippet,
			editorAPI,
		});
	};

	const handleDuplicate = (snippet: Snippet) => {
		// TODO: Implement duplicate (e.g. open duplicate modal or inline flow)
		onDuplicate?.(snippet);
	};

	const handleDelete = (snippet: Snippet) => {
		showModal(DeleteSnippetModal, { snippet, editorAPI });
	};

	return { handleEdit, handleDuplicate, handleDelete };
};
